import { createFileRoute } from "@tanstack/react-router";
import type { JSX } from "react";
import TeamsLoginPage from "@/components/teams/teams-login-page";

const TeamsLoginRoute = (): JSX.Element => <TeamsLoginPage />;

export const Route = createFileRoute("/teams/login/")({
	component: TeamsLoginRoute,
});
